class CampaignLink extends window.BAO.CustomElement() {
  setupListeners() {
    super.setupListeners()

    if (this.els?.link?.exists === true) {
      this.listeners.add(
        this.els.link.element,
        'click',
        this.handleLinkClick.bind(this),
      )
    }

    if (this.externalEls?.return?.exists === true) {
      this.listeners.add(
        this.externalEls.return.element,
        'click',
        this.handleReturnClick.bind(this),
      )
    }
  }

  async handleLinkClick(e) {
    e.preventDefault()

    const link = e.target.href
    const campaignProduct = e.target.dataset.campaignProduct
    const campaignPage = e.target.dataset.campaignPage

    if (typeof link === 'undefined' || typeof campaignProduct === 'undefined' || typeof campaignPage === 'undefined') return

    try {
      await window.BAO.Cart.updateCartAttributes({
        campaign: {
          product: campaignProduct,
          page: campaignPage,
        },
      })

      window.location = link
    } catch (error) {
      console.error(error)
    }
  }

  async handleReturnClick(e) {
    e.preventDefault()

    const link = e.target.href

    if (typeof link === 'undefined') return

    try {
      await window.BAO.Cart.updateCartAttributes({
        campaign: null,
      })

      window.location = link
    } catch (error) {
      console.error(error)
    }
  }
}

if (!customElements.get('campaign-link')) {
  customElements.define('campaign-link', CampaignLink)
}
